'use client';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
// import Button from "@mui/material/Button";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useUserContext } from '../contexts/UserContext';
import * as _ from 'lodash';
import Cookies from 'js-cookie';
import Chart from './Chart';
import {
  MagnifyingGlassIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowTopRightOnSquareIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DeleteIcon,
} from '@heroicons/react/24/outline';
import mqtt from 'mqtt';
import { ResponsiveContainer, ScatterChart, XAxis, YAxis, Tooltip, Scatter, CartesianGrid, Rectangle } from 'recharts';
import { set } from 'date-fns';

let signalstopic = 'goldensparrowcapital-signals';

const Symbols = props => {
  const {
    user
  } = useUserContext();

  const [section, setSection] = useState('Active')
  const [client, setClient] = useState(null);
  const mqttClientRef = useRef(null); // holds the MQTT client instance
  const mqttListenerAttached = useRef(false); // ensures only one message handler is attached
  const wsRefBinance = useRef(null);
  const [lastUpdated, setLastUpdated] = useState(new Date().valueOf());
  const [isProcessing, setIsProcessing] = useState(false)
  const [symbols, setSymbols] = useState([])
  const [sidePanel, setSidePanel] = useState({
    visible: false,
    symbol: null,
    lastUpdated: new Date().valueOf(),
    strategies: [],
    fvg : [],
    heavyTrade : [],
    currentPrices : [],
    rsiCrossedSmaBelowBbMiddle : [],
    belowBBLower : [],
    heavyAbsorption : [],
    heavySelling : [],
    breakoutPhaseStarted : [],
    artificialPumpStarted : [],
    spoofingLayeringDetected : [],
    absorptionViaStreams : [],
    dollarValue : []

  })
  const [recentlyViewed, setRecentlyViewed] = useState([]);

  const [xDomain, setXDomain] = useState(['dataMin', 'dataMax']);
  const [yDomain, setYDomain] = useState(['dataMin', 'dataMax']);
  const origDomainsRef = useRef({ x: null, y: null });
 

  const addIntoRecentlyViewed = (symbol) => {
    //check if symbol already exists in recentlyViewed
    setRecentlyViewed((prev) => {
      const updated = [...prev];
      const index = updated.findIndex((item) => item.symbol === symbol);
      if (index == -1) {
        //add it to the recentlyViewed
        //use push
        updated.push({ symbol, creationDate: Date.now() });
      }
      return updated;
    });
  };

  const removeFromRecentlyViewed = (symbol) => {
    setRecentlyViewed((prev) => {
      const updated = [...prev];
      const index = updated.findIndex((item) => item.symbol === symbol);
      if (index !== -1) {
        updated.splice(index, 1);
      }
      return updated;
    });
  };

  // Render Metric shapes inside the Scatter plot
  // Recharts provides pixel coordinates cx/cy for each point — use them if valid.



  //connect and subscribe to MQTT broker
  const _connectMQTT = useCallback(async (props) => {
    if (mqttClientRef.current) return; // already connected
    let clientID = 'GoldenSparrowCapital-' + user.user_uuid;
    const gsccookie = Cookies.get('gsccookie') || null;
    const newClient = mqtt.connect(process.env.REACT_APP_EXTERNAL_MQTT_SERVER_URL, {
      clientId: clientID,
      username: 'user-jwt',
      password: gsccookie,
      clean: true,
      rejectUnauthorized: true,
      reconnectPeriod: 60000,
    });
    mqttClientRef.current = newClient;
    setClient(newClient);

    newClient.on('connect', async () => {
      console.log('Connected to MQTT:', new Date().toLocaleTimeString());

      [
        'RECEIVE_SYMBOLS_WEB',
        'RECEIVE_SYMBOL_STRATEGIES_AND_METRICS_WEB'
      ].forEach(topic => {
        newClient.unsubscribe(topic);
        newClient.subscribe(topic, err => {
          if (err) {
            console.error('Topic Subscribe error', err);
          }
        });
      });
    });
  }, [setClient, setIsProcessing]);

  //i want publishGetSymbolsList() to be called every 1 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      publishGetSymbolsList();
      if (sidePanel.visible) {
        publishGetSymbolData(sidePanel.symbol);
      }
    }, 1 * 60 * 1000); // 1 minutes
    return () => clearInterval(interval);
  }, [client, sidePanel]);

  useEffect(() => {
    if (!client || mqttListenerAttached.current) return;
    const handler = (topic, message = '') => {
      //  console.log('Received Topic:', topic, new Date().toLocaleTimeString());
      if (topic === 'RECEIVE_SYMBOLS_WEB') {
        let mm = JSON.parse(message);
        //  console.log("Symbols:", mm.symbols)

        setSymbols(prev => [...mm.symbols]);
        setLastUpdated(new Date().valueOf());
      }
      if (topic === 'RECEIVE_SYMBOL_STRATEGIES_AND_METRICS_WEB') {
        let mm = JSON.parse(message);
        // console.log("Strategies and Metrics:", mm)

    
        setSidePanel(prev => ({
          ...prev,
          strategies: mm.strategies || [],
          fvg : (mm.metrics || []).filter(item => item.metricName === 'FVG' && item.timeFrame == "4h" && item.candleMinus1 && item.candleMinus2 && item.candleMinus3),
          heavyTrade : (mm.metrics || []).filter(item => item.metricName === 'HEAVY-TRADE'),
          currentPrices : (mm.metrics || []).filter(item => item.metricName === 'CURRENT-PRICE'),
          rsiCrossedSmaBelowBbMiddle : (mm.metrics || []).filter(item => item.metricName === 'RSI_CROSSED_SMA_BELOW_BBMIDDLE'),
          belowBBLower : (mm.metrics || []).filter(item => item.metricName === 'BELOW_BBLOWER'),
          heavyAbsorption : (mm.metrics || []).filter(item => item.metricName === 'HEAVY-ABSORPTION'),
          heavySelling : (mm.metrics || []).filter(item => item.metricName === 'HEAVY-SELLING'),
          dollarValue : (mm.metrics || []).filter(item => item.metricName === 'DOLLAR_VALUE'),
          // breakoutPhaseStarted : (mm.metrics || []).filter(item => item.metricName === 'BREAKOUT_PHASE_START'),
          // artificialPumpStarted : (mm.metrics || []).filter(item => item.metricName === 'ARTIFICIAL_PUMP_DETECTED'),
          // spoofingLayeringDetected : (mm.metrics || []).filter(item => item.metricName === 'SPOOFING_LAYERING_DETECTED'),
          absorptionViaStreams : (mm.metrics || []).filter(item => item.metricName === 'ABSORPTION_DETECTED'),
          lastUpdated: Date.now(),
        }));

       

        // console.log one object of metricName == "FVG"
       // console.log("FVG Metric:", (mm.metrics || []).find(item => item.metricName === 'FVG' && item.type === 'PRIMARY' && item.timeFrame == "4h"));
        //console.log("HEAVY-TRADE Metric:", (mm.metrics || []).find(item => item.metricName === 'HEAVY-TRADE'));

       

      }

    };
    client.on('message', handler);
    mqttListenerAttached.current = true;
    return () => {
      if (mqttClientRef.current) {
        mqttClientRef.current.end();
        mqttClientRef.current = null;
        setClient(null);
        mqttListenerAttached.current = false;
      }
    };
  }, [client, setIsProcessing]);

  useEffect(() => {
    _connectMQTT(props);
    publishGetSymbolsList();
  }, []);

  const publishGetSymbolsList = useCallback(() => {
    const client = mqttClientRef.current;
    const gsccookie = Cookies.get('gsccookie') || null;

    const doPublish = (c) => {
      if (!c || typeof c.publish !== 'function') {
        console.error('MQTT client not available for publish');
        return;
      }
      c.publish('GET_SYMBOLS', JSON.stringify({ token: gsccookie }), err => {
        if (!err) {
          setIsProcessing(true);
          console.log('GET_SYMBOLS request published:', new Date().toLocaleTimeString());
        } else {
          console.error('Topic Publish error', err);
        }
      });
    };

    if (!client || client.disconnected) {
      // ensure a connection is attempted and publish once connected
      _connectMQTT();
      const onConnect = () => {
        const c = mqttClientRef.current;
        doPublish(c);
        if (c && typeof c.removeListener === 'function') {
          c.removeListener('connect', onConnect);
        }
      };
      // attach listener if client exists, otherwise _connectMQTT's connect handler will trigger publish when client is ready
      if (mqttClientRef.current && typeof mqttClientRef.current.on === 'function') {
        mqttClientRef.current.on('connect', onConnect);
      }
      return;
    }

    doPublish(client);
  }, [_connectMQTT, setIsProcessing]);

  const publishGetSymbolData = useCallback((symbol) => {
    setSidePanel(prev => ({
      ...prev,
      symbol: symbol,
      visible: true,
      lastUpdated: new Date().valueOf()
    }));

    const client = mqttClientRef.current;

    const gsccookie = Cookies.get('gsccookie') || null;

    const doPublish = (c, s) => {
      if (!c || typeof c.publish !== 'function') {
        console.error('MQTT client not available for publish');
        return;
      }
      c.publish('GET_SYMBOL_STRATEGIES_AND_METRICS',
        JSON.stringify({ token: gsccookie, symbol: s }), err => {
          if (!err) {
            setIsProcessing(true);
            console.log('GET_SYMBOL_STRATEGIES_AND_METRICS request published:', new Date().toLocaleTimeString());
          } else {
            console.error('Topic Publish error', err);
          }
        });
    };

    if (!client || client.disconnected) {
      // ensure a connection is attempted and publish once connected
      _connectMQTT();
      const onConnect = () => {
        const c = mqttClientRef.current;
        doPublish(c);
        if (c && typeof c.removeListener === 'function') {
          c.removeListener('connect', onConnect);
        }
      };
      // attach listener if client exists, otherwise _connectMQTT's connect handler will trigger publish when client is ready
      if (mqttClientRef.current && typeof mqttClientRef.current.on === 'function') {
        mqttClientRef.current.on('connect', onConnect);
      }
      return;
    }

    doPublish(client, symbol);

  }, [_connectMQTT, setIsProcessing]);

  const deleteSymbol = useCallback((symbol) => {

    //delete from symbols 
    setSymbols(prev => prev.filter(item => item.symbol !== symbol));

    const client = mqttClientRef.current;
    const gsccookie = Cookies.get('gsccookie') || null;

    const doPublish = (c) => {
      if (!c || typeof c.publish !== 'function') {
        console.error('MQTT client not available for publish');
        return;
      }
      c.publish('DELETE_SYMBOL_FROM_LIST', JSON.stringify({ token: gsccookie, symbol }), err => {
        if (!err) {
          setIsProcessing(true);
          console.log('DELETE_SYMBOL_FROM_LIST request published:', new Date().toLocaleTimeString());
        } else {
          console.error('Topic Publish error', err);
        }
      });
    };

    if (!client || client.disconnected) {
      // ensure a connection is attempted and publish once connected
      _connectMQTT();
      const onConnect = () => {
        const c = mqttClientRef.current;
        doPublish(c);
        if (c && typeof c.removeListener === 'function') {
          c.removeListener('connect', onConnect);
        }
      };
      // attach listener if client exists, otherwise _connectMQTT's connect handler will trigger publish when client is ready
      if (mqttClientRef.current && typeof mqttClientRef.current.on === 'function') {
        mqttClientRef.current.on('connect', onConnect);
      }
      return;
    }

    doPublish(client);
  }, [_connectMQTT, setIsProcessing]);





  return symbols ? (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100">

      {/* Main Page */}
      {!sidePanel.visible && (
      <div className="flex">
        <main className="flex-1 p-0">
          <header className="mb-6">
            <h1 className="text-2xl font-bold">Symbols</h1>
          </header>
          <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, color: '#fff', marginBottom: 3 }}> Last Updated: {new Date(lastUpdated).toLocaleDateString()} ,{' '}
            {new Date(lastUpdated).toLocaleTimeString()}
          </h1>
          <h1 className="text-sm" style={{ margin: 0, paddingTop: 1, color: '#fff', marginBottom: 3 }}> Count: {' '}
            {symbols.length}
          </h1>

          {recentlyViewed.length > 0 ?
            <div className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg" style={{ padding: 10 }}>

              <h1 className="text-sm" style={{ margin: 0, paddingTop: 1, color: '#fff', marginBottom: 3, marginTop: 5, fontWeight: "bold" }}> Recently Viewed: </h1>
              <div>
                {recentlyViewed.map((item, index) => (
                  //display the name of each symbol in new line and also give a button to remove it from the recentlyViewed

                  <div key={index} style={{ display: 'flex', gap: 5, marginTop: 5 }}>

                    <h2 style={{ fontSize: 12 }}>{index + 1}. {item.symbol}</h2>
                    <button style={{
                      backgroundColor: '#fe0000ff',
                      fontSize: 12,
                      borderRadius: 5,
                      padding: 3,
                      alignItems: 'center', display: 'flex',

                    }}
                      onClick={() => removeFromRecentlyViewed(item.symbol)}>
                      Remove
                    </button>
                    <button
                      style={{
                        backgroundColor: '#7e8082ff',
                        fontSize: 12,
                        borderRadius: 5,
                        padding: 3,
                        alignItems: 'center', display: 'flex',

                      }}
                      onClick={() => {
                        window.open(
                          'https://www.coinglass.com/tv/Binance_' + item.symbol,
                          '_blank'
                        )

                      }}
                    >
                      <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>CoinGlass</h4>
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
                      >
                        {/* Dark background circle matching trading terminal themes */}
                        <circle cx="16" cy="16" r="16" fill="#1E222D" />

                        {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                        <path
                          d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                          stroke="#ffffff"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />

                        {/* Subtle outer border for depth */}
                        <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                      </svg>

                    </button>
                    <button
                      style={{
                        backgroundColor: '#7e8082ff',
                        fontSize: 12,
                        borderRadius: 5,
                        padding: 3,
                        alignItems: 'center', display: 'flex',

                      }}
                      onClick={() => {
                        window.open(
                          'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + item.symbol,
                          '_blank'
                        )

                      }}
                    >
                      <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Trading View</h4>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
                      >
                        {/* Standard Terminal Background */}
                        <circle cx="16" cy="16" r="16" fill="#1E222D" />

                        {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                        <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                        <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                        <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                        {/* Border for UI consistency */}
                        <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                      </svg>
                    </button>
                    <button
                      style={{
                        backgroundColor: '#298f09ff',
                        fontSize: 12,
                        borderRadius: 5,
                        padding: 3,
                        alignItems: 'center', display: 'flex',

                      }}
                      onClick={async () => {
                        addIntoRecentlyViewed(item.symbol);
                        await publishGetSymbolData(item.symbol);
                      }}
                    >
                      <h5 style={{ fontWeight: 'bolder' }}>Show more...</h5>
                    </button>

                  </div>

                ))}
              </div>
            </div>
          : null}

          <table
            style={{ marginTop: 5 }}
            className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
            <thead>
              <tr>
                <th className="py-2 px-4 border-b text-left text-xs">Symbol</th>
                <th className="py-2 px-4 border-b text-center text-xs">Metric Name</th>
                <th className="py-2 px-4 border-b text-center text-xs">Timeframe</th>
                <th className="py-2 px-4 border-b text-center text-xs">Last Updated</th>
                    {/* <th className="py-2 px-4 border-b">Data </th> 
                <th className="py-2 px-4 border-b">Metric Name</th>
                <th className="py-2 px-4 border-b">TimeFrame</th> */}
              </tr>
            </thead>
            <tbody>
              {
                // order by desc updatedDate using numeric timestamp to ensure proper sorting
                // Ensure numeric sorting: coerce updatedDate and fvgPercentage to numbers before ordering.
                _.orderBy(
                  symbols,
                  // [
                  //   // bucket updatedDate to the hour only (ignore minutes/seconds) for sorting
                  //   (s) => {
                  //     if (s == null) return 0;
                  //     let t = Number(s.updatedDate);
                  //     if (!Number.isFinite(t)) {
                  //       const parsed = Date.parse(String(s.updatedDate || ''));
                  //       t = Number.isFinite(parsed) ? parsed : 0;
                  //     }
                  //     // return hour bucket (hours since epoch) so sorting ignores minutes/seconds
                  //     return t ? Math.floor(t / 3600000) : 0;
                  //   },
                  //   (s) => {
                  //     // fvgPercentage may be a string (e.g. '12' or '12.3') — coerce to number
                  //     // also allow values like '12%' by stripping non-numeric characters
                  //     if (s == null) return 0;
                  //     const raw = s.fvgPercentage;
                  //     if (raw == null) return 0;
                  //     const num = Number(String(raw).replace(/[^0-9.-]+/g, ''));
                  //     return Number.isFinite(num) ? num : 0;
                  //   }
                  // ],
                  ["updatedDate"],
                  ['desc']
                )
                 
                  .map((item, index) => (
                    <tr key={index}>
                      <td className="py-2 px-4 border-b flex items-center">
                        <div style={{ alignItems: 'center', display: 'flex', gap: 5 }}>
                          <h2>{index + 1}.</h2>
                          <h2 style={{ fontSize: 12 }}>{item.symbol}</h2>
                          <button
                            style={{
                              backgroundColor: '#7e8082ff',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 3,
                              alignItems: 'center', display: 'flex'
                            }}
                            onClick={() => {
                              window.open(
                                'https://www.coinglass.com/tv/Binance_' + item.symbol,
                                '_blank'
                              )

                            }}
                          >
                            <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>CoinGlass</h4>
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
                            >
                              {/* Dark background circle matching trading terminal themes */}
                              <circle cx="16" cy="16" r="16" fill="#1E222D" />

                              {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                              <path
                                d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                                stroke="#ffffff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />

                              {/* Subtle outer border for depth */}
                              <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                            </svg>

                          </button>
                          <button
                            style={{
                              backgroundColor: '#7e8082ff',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 3,
                              alignItems: 'center', display: 'flex'
                            }}
                            onClick={() => {
                              window.open(
                                'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + item.symbol,
                                '_blank'
                              )

                            }}
                          >
                            <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Trading View</h4>
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
                            >
                              {/* Standard Terminal Background */}
                              <circle cx="16" cy="16" r="16" fill="#1E222D" />

                              {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                              <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                              <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                              <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                              {/* Border for UI consistency */}
                              <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                            </svg>
                          </button>
                          <button
                            style={{
                              backgroundColor: '#298f09ff',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 3,
                              alignItems: 'center', display: 'flex',

                            }}
                            onClick={async () => {
                              addIntoRecentlyViewed(item.symbol);
                              await publishGetSymbolData(item.symbol);
                            }}
                          >
                            <h5 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Show more...</h5>


                          </button>
                          <button
                            style={{
                              backgroundColor: 'red',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 3,
                              alignItems: 'center', display: 'flex',

                            }}
                            onClick={async () => {
                              deleteSymbol(item.symbol);
                            }}
                          >
                            <h5 style={{ fontWeight: 'bolder' }}>Delete</h5>
                          </button>
                        </div>
                      </td>
                        <td className="py-2 px-4 border-b text-center text-xs">{item?.metricName}</td>
                      <td className="py-2 px-4 border-b text-center text-xs">{item.timeFrame}</td>
                      <td className="py-2 px-4 border-b text-center" style={{ fontSize: 9 }}>{new Date(item.updatedDate).toLocaleString()}</td>

                    
                    </tr>
                  ))}
            </tbody>
          </table>
        </main>
      </div>
      )}

      {sidePanel.visible && (
        <div>
          <div style={{
          //  borderRadius: "5px", 
            display: "flex",
           // borderBottom: "1px solid #eee"
          }}>

            <h5 style={{ color: "#fff", padding: "5px", fontWeight: "bold" }}>{sidePanel.symbol}</h5>

            <button
              style={{
                backgroundColor: '#7e8082ff',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {
                window.open(
                  'https://www.coinglass.com/tv/Binance_' + sidePanel.symbol,
                  '_blank'
                )

              }}
            >
              <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>CoinGlass</h4>
              <svg
                width="15"
                height="15"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
              >
                {/* Dark background circle matching trading terminal themes */}
                <circle cx="16" cy="16" r="16" fill="#1E222D" />

                {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                <path
                  d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                  stroke="#ffffff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />

                {/* Subtle outer border for depth */}
                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
              </svg>

            </button>
            <button
              style={{
                backgroundColor: '#7e8082ff',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {
                window.open(
                  'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + sidePanel.symbol,
                  '_blank'
                )

              }}
            >
              <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Trading View</h4>
              <svg
                width="20"
                height="20"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
              >
                {/* Standard Terminal Background */}
                <circle cx="16" cy="16" r="16" fill="#1E222D" />

                {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                {/* Border for UI consistency */}
                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
              </svg>
            </button>
            <button
              style={{
                backgroundColor: '#ff0000',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {

                setSidePanel(prev => ({
                  ...prev,
                  symbol: null,
                  visible: false,
                  strategies: [],
                  fvg: [],
                  heavyTrade: [],
                  currentPrices: [],
                  lastUpdated: null,
                  rsiCrossedSmaBelowBbMiddle: [],
                  belowBBLower: [],
                  heavyAbsorption: [],
                  heavySelling : [],
                  dollarValue: [],
                  breakoutPhaseStarted: [],
                  artificialPumpStarted: [],
                  spoofingLayeringDetected: [],
                  absorptionViaStreams: []

                }));


              }}
            >
              <h4 style={{ fontWeight: 'bolder', color: 'white' }}>Close</h4>


            </button>

          </div>
            <span style={{ fontSize: 11, color: '#fff', marginLeft: 5 }}>
            Last Updated: {new Date(sidePanel.lastUpdated).toLocaleString()}
          </span>
 <div style={{ height: 800, width: '98%', margin: 5, alignContent: 'center', justifyContent: 'center', padding: 10 }}>


<Chart 
fvgs={sidePanel.fvg} 
heavyTrades={sidePanel.heavyTrade} 
currentPrices={sidePanel.currentPrices} 
rsiCrossedSmaBelowBbMiddle={sidePanel.rsiCrossedSmaBelowBbMiddle} 
belowBBLower={sidePanel.belowBBLower}
heavyAbsorption={sidePanel.heavyAbsorption}
heavySelling={sidePanel.heavySelling}

// breakoutPhaseStarted={sidePanel.breakoutPhaseStarted}
// artificialPumpStarted={sidePanel.artificialPumpStarted}
// spoofingLayeringDetected={sidePanel.spoofingLayeringDetected}
absorptionViaStreams={sidePanel.absorptionViaStreams}
dollarValue={sidePanel.dollarValue}

/>

           
          </div>
          </div>
      )
      }

      {/* Side Panel */}
      {/* {sidePanel.visible && (
        <div
          role="dialog"
          aria-label="Data panel"
          style={{
            position: 'fixed',
            right: 0,
            top: 0,
            bottom: 0,
            width: '1200px',
            maxWidth: '100%',
            backgroundColor: '#fff',
            borderLeft: '1px solid #eee',
            padding: 5,
            overflowY: 'auto',
            zIndex: 9999,
            boxShadow: '-4px 0 12px rgba(0,0,0,0.08)',
            transition: 'transform 180ms ease',
            willChange: 'transform',
          }}
        >

          <div style={{

            borderRadius: "5px", display: "flex",
            borderBottom: "1px solid #eee"
          }}>

            <h5 style={{ color: "black", padding: "5px", fontWeight: "bold" }}>{sidePanel.symbol}</h5>

            <button
              style={{
                backgroundColor: '#7e8082ff',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {
                window.open(
                  'https://www.coinglass.com/tv/Binance_' + sidePanel.symbol,
                  '_blank'
                )

              }}
            >
              <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>CoinGlass</h4>
              <svg
                width="15"
                height="15"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
              >
               
                <circle cx="16" cy="16" r="16" fill="#1E222D" />

              
                <path
                  d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                  stroke="#ffffff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />

               
                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
              </svg>

            </button>
            <button
              style={{
                backgroundColor: '#7e8082ff',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {
                window.open(
                  'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + sidePanel.symbol,
                  '_blank'
                )

              }}
            >
              <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Trading View</h4>
              <svg
                width="20"
                height="20"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
              >
            
                <circle cx="16" cy="16" r="16" fill="#1E222D" />

               <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
              </svg>
            </button>
            <button
              style={{
                backgroundColor: '#ff0000',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {

                setSidePanel(prev => ({
                  ...prev,
                  symbol: null,
                  visible: false,
                  strategies: [],
                  fvg: [],
                  heavyTrade: [],
                  currentPrices: [],
                  lastUpdated: null,
                  rsiCrossedSmaBelowBbMiddle: [],
                  belowBBLower: [],
                  heavyAbsorption: [],
                  heavySelling : [],
                  dollarValue: [],
                  breakoutPhaseStarted: [],
                  artificialPumpStarted: [],
                  spoofingLayeringDetected: [],
                  absorptionViaStreams: []

                }));


              }}
            >
              <h4 style={{ fontWeight: 'bolder', color: 'white' }}>Close</h4>


            </button>

          </div>
          <span style={{ fontSize: 11, color: 'grey', marginLeft: 5 }}>
            Last Updated: {new Date(sidePanel.lastUpdated).toLocaleString()}
          </span>
          <br></br>
         

          <span style={{ fontSize: 15, color: 'grey', marginLeft: 5, fontWeight: 'bold' }}>
            RSI_CROSSED_SMA_BELOW_BBMIDDLE: {sidePanel.rsiCrossedSmaBelowBbMiddle.length}
          </span>
           <span style={{ fontSize: 15, color: 'grey', marginLeft: 5, fontWeight: 'bold' }}>
            Heavy Absorption: {sidePanel.heavyAbsorption.length}
          </span>
           
          <span style={{ fontSize: 15, color: 'grey', marginLeft: 5, fontWeight: 'bold' }}>
            Heavy Selling: {sidePanel.heavySelling.length}
          </span>

         
          <span style={{ fontSize: 15, color: 'grey', marginLeft: 5, fontWeight: 'bold' }}>
            AbsorptionViaStreams: {sidePanel.absorptionViaStreams.length}
          </span> 

          <div style={{ height: 800, width: '98%', margin: 20, alignContent: 'center', justifyContent: 'center', padding: 25 }}>


<Chart 
fvgs={sidePanel.fvg} 
heavyTrades={sidePanel.heavyTrade} 
currentPrices={sidePanel.currentPrices} 
rsiCrossedSmaBelowBbMiddle={sidePanel.rsiCrossedSmaBelowBbMiddle} 
belowBBLower={sidePanel.belowBBLower}
heavyAbsorption={sidePanel.heavyAbsorption}
heavySelling={sidePanel.heavySelling}

// breakoutPhaseStarted={sidePanel.breakoutPhaseStarted}
// artificialPumpStarted={sidePanel.artificialPumpStarted}
// spoofingLayeringDetected={sidePanel.spoofingLayeringDetected}
absorptionViaStreams={sidePanel.absorptionViaStreams}
dollarValue={sidePanel.dollarValue}

/>

           
          </div>
        </div>
      )} */}
    </div>
  ) : null;

};


export default Symbols;
